<template>
  <div>
    <validation-observer ref="sysEmpObserver">
      <b-sidebar
        id="addSystemEmployee"
        bg-variant="white"
        right
        backdrop
        shadow
        width="520px"
        class="sidebar-form"
        @hidden="sidebarToggle"
      >
        <!-- Header -->
        <h3 class="form-title">
          {{ id ? 'Edit' : 'Add' }} External User
        </h3>
        <div class="line user-underline" />

        <!-- Profile Picture -->
        <!-- <b-form-group
          label="Profile Picture"
          label-for="sys-picture"
        >
          <div class="emp-picture-wrap">
            <div class="emp-avatar-preview">
              <b-avatar
                size="72"
                :src="picturePreview"
                :text="avatarInitials"
                variant="light-primary"
                class="emp-avatar"
              />
              <div
                class="emp-avatar-overlay"
                @click="$refs.pictureInput.click()"
              >
                <feather-icon
                  icon="CameraIcon"
                  size="16"
                  class="text-white"
                />
              </div>
            </div>
            <input
              ref="pictureInput"
              type="file"
              accept="image/jpeg,image/png,image/gif"
              style="display:none"
              @change="onPictureChange"
            >
            <div class="emp-picture-info">
              <button
                type="button"
                class="btn emp-upload-btn"
                @click="$refs.pictureInput.click()"
              >
                <feather-icon icon="UploadIcon" size="13" class="mr-50" />
                {{ pictureFile ? 'Change Photo' : 'Upload Photo' }}
              </button>
              <small class="text-muted d-block mt-25">
                {{ pictureFile ? pictureFile.name : 'JPG, PNG up to 2MB' }}
              </small>
            </div>
          </div>
        </b-form-group> -->

        <!-- Employee ID -->
        <b-form-group
          label="Employee ID"
          label-for="sys-emp-id"
          class="required-form-filed"
        >
          <validation-provider
            #default="{ errors }"
            name="Employee ID"
            rules="required|max:20"
          >
            <b-form-input
              id="sys-emp-id"
              v-model="emp_id"
              :state="errors.length > 0 ? false : null"
              placeholder="e.g. ZIG-001"
              name="emp_id"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- First Name & Last Name -->
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="First Name"
              label-for="sys-first-name"
              class="required-form-filed"
            >
              <validation-provider
                #default="{ errors }"
                name="First name"
                rules="required|max:40"
              >
                <b-form-input
                  id="sys-first-name"
                  v-model="name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="First Name"
                  name="name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Last Name"
              label-for="sys-last-name"
              class="required-form-filed"
            >
              <validation-provider
                #default="{ errors }"
                name="Last name"
                rules="required|alpha_spaces|max:40"
              >
                <b-form-input
                  id="sys-last-name"
                  v-model="last_name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Last Name"
                  name="last_name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>


        <!-- Phone & Role -->
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Contact No."
              label-for="sys-phone"
            >
              <validation-provider
                #default="{ errors }"
                name="Contact no."
              >
                <b-form-input
                  id="sys-phone"
                  v-model="phone"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Contact No."
                  name="phone"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Role"
              label-for="sys-role"
              class="role-select required-form-filed"
            >
              <validation-provider
                #default="{ errors }"
                name="Role"
                rules="required"
              >
                <v-select
                  v-model="role"
                  hide-details
                  name="role"
                  label="name"
                  :options="roleOptions"
                  :reduce="(r) => r.code"
                  class="select-size-lg"
                  placeholder="Select Role"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Reporting To -->
        <b-form-group
          label="Reporting To"
          label-for="sys-reporting-to"
          class="role-select required-form-filed"
        >
          <validation-provider
            #default="{ errors }"
            name="Reporting to"
            rules="required"
          >
            <v-select
              v-model="reporting_to"
              hide-details
              name="reporting_to"
              label="label"
              :options="userOptions"
              :reduce="(u) => u.value"
              class="select-size-lg"
              placeholder="Select Reporting To"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Managed By -->
        <b-form-group
          label="Managed By"
          label-for="sys-manage-by"
          class="role-select required-form-filed"
        >
          <validation-provider
            #default="{ errors }"
            name="Managed by"
            rules="required"
          >
            <v-select
              v-model="manage_by"
              hide-details
              name="manage_by"
              label="label"
              :options="userOptions"
              :reduce="(u) => u.value"
              class="select-size-lg"
              placeholder="Select Managed By"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Date of Joining -->
        <b-form-group
          label="Date of Joining"
          label-for="sys-doj"
        >
          <validation-provider
            #default="{ errors }"
            name="Date of joining"
          >
            <b-form-input
              id="sys-doj"
              v-model="date_of_joining"
              :state="errors.length > 0 ? false : null"
              type="date"
              name="date_of_joining"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Shift -->
        <b-form-group
          label="Shift"
          label-for="sys-shift"
          class="role-select required-form-filed"
        >
          <validation-provider
            #default="{ errors }"
            name="Shift"
            rules="required"
          >
            <v-select
              id="sys-shift"
              v-model="shift_id"
              :options="shiftOptions"
              :reduce="s => s.value"
              label="label"
              class="select-size-lg"
              placeholder="Select Shift"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Working Mode -->
        <b-form-group
          label="Working Mode"
          label-for="sys-working-mode"
          class="role-select"
        >
          <v-select
            id="sys-working-mode"
            v-model="working_mode"
            :options="workingModeOptions"
            :reduce="m => m.value"
            label="label"
            class="select-size-lg"
            placeholder="Select Working Mode"
          />
        </b-form-group>

        <!-- Footer -->
        <template #footer>
          <div class="form-button d-flex my-2">
            <button
              class="btn side-bar-btn"
              type="submit"
              :disabled="btnLoader"
              @click.prevent="validationForm"
            >
              <b-spinner
                v-if="btnLoader"
                small
                class="spinner"
              />
              {{ id ? 'Update' : 'Save' }}
            </button>
            <button
              class="btn side-bar-btn"
              type="button"
              @click="$root.$emit('bv::toggle::collapse', 'addSystemEmployee')"
            >
              Cancel
            </button>
          </div>
        </template>
      </b-sidebar>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import SystemEmployeeFormMixin from '@/mixin/masterSetting/SystemEmployee/SystemEmployeeForm'

export default {
  name: 'SystemEmployeeForm',
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [SystemEmployeeFormMixin],
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/component-css/systemEmployeeForm.scss";
</style>
